module.exports = __webpack_public_path__ + "images/top-losers-black-5a1db9b7.svg";